
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-crop",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-crop"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.13 1L6 16a2 2 0 002 2h15"}}),_c('path',{attrs:{"d":"M1 6.13L16 6a2 2 0 012 2v15"}})])
          )
        }
      }
    